const Tooltip = ({ text, display, dimensions }) => {
    return (
        <div
            className="tooltip"
            style={{
                position: 'absolute',
                display,
                top: `${dimensions[1] + 100}px`,
                left: `${dimensions[0] / 2}px`,
            }}
        >
            <h3>{text.name}</h3>
            <table>
                <tr>
                    <td />
                    <td className="head">2014</td>
                    <td className="head">
                        Change
                        <br />
                        2000-2014
                    </td>
                </tr>
                <tr className="tooltip-row">
                    <td>Upper income</td>
                    <td>{text.up_share}%</td>
                    <td>
                        {text.up_change}{' '}
                        {0 < text.up_share ? 'points' : 'point'}
                    </td>
                </tr>
                <tr className="tooltip-row">
                    <td>Middle income</td>
                    <td>{text.mid_share}</td>
                    <td>{text.mid_change}</td>
                </tr>
                <tr className="tooltip-row">
                    <td>Lower income</td>
                    <td>{text.low_share}</td>
                    <td>{text.low_change}</td>
                </tr>
            </table>
        </div>
    );
};

export default Tooltip;
